// removed by extract-text-webpack-plugin
module.exports = {"MainContainer":"PersonalDataForm__MainContainer__1DpBA","FormContainer":"PersonalDataForm__FormContainer__1YryM","Form":"PersonalDataForm__Form__17ODj","InputContainer":"PersonalDataForm__InputContainer__1RcuV","InputContainerEven":"PersonalDataForm__InputContainerEven__2vFeg","TextRecapBooking":"PersonalDataForm__TextRecapBooking__3D93n","PrivacyPolicyLink":"PersonalDataForm__PrivacyPolicyLink__3r-OF","Text":"PersonalDataForm__Text__36w7o","SmallText":"PersonalDataForm__SmallText__BwzwC","EmailPrivacy":"PersonalDataForm__EmailPrivacy__2NDhP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PersonalDataForm/PersonalDataForm.css
// module id = 230
// module chunks = 0